export default {
  globalRate: {
    id: 'review_form_global_rate',
    defaultMessage: 'Your overall rating',
  },
} as const
